import { useSelector } from 'react-redux';

export const useCategories = () =>
  useSelector(({ categories: { featured, category } }) => ({
    featured,
    category
  }));
